import { LWA_TOKEN_OBJECT_IDENTIFIER, tokenTypes } from "../../constants/auth";
import { navigateToLogout, navigateToPlatformUI } from "../../constants/nav";

export const getIsTokenExpired = (tokenInfo) => {
    if (!tokenInfo) return;
    const tokenExpireDate = new Date(tokenInfo.exp * 1000);
    const now = new Date();
    return now > tokenExpireDate;
};

export const expiredTokenActionByToken = ({
    [tokenTypes.KEYCLOAK]: () => navigateToLogout(),
    [tokenTypes.LWA]: () => navigateToPlatformUI(),
});

export const getLwaIdFromTokenInfo = tokenInfo => tokenInfo?.[LWA_TOKEN_OBJECT_IDENTIFIER]?.uid ?? '';
